import { createContext, useContext, useState } from 'react'

const ModalContext = createContext()

export function ModalProvider({ children, pagarmePublicKey = null }) {
  const [isOpen, setIsOpen] = useState(false)
  const [plan, setPlan] = useState(null)
  const [planId, setPlanId] = useState(null)
  const [planSpecialist, setPlanSpecialist] = useState(false)
  const [planSpecialtyLimit, setPlanSpecialtyLimit] = useState(0)

  return (
    <ModalContext.Provider value={{
      isOpen,
      plan,
      planId,
      planSpecialist,
      planSpecialtyLimit,
      pagarmePublicKey,
      openModal: (planData) => {
        setPlan(planData?.name ?? null)
        setPlanId(planData?.id ?? null)
        setPlanSpecialist(!!planData?.specialist)
        setPlanSpecialtyLimit(planData?.included_specialties_count || 0)
        setIsOpen(true)
      },
      closeModal: () => setIsOpen(false),
    }}>
      {children}
    </ModalContext.Provider>
  )
}

export function useModal() {
  return useContext(ModalContext)
}